/* eslint-disable */
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import ConfigurationScreenNavbarItem from './ConfigurationScreenNavbarItem/ConfigurationScreenNavbarItem';

import MenuItems from './ConfigurationScreenNavbarItem/navbarItems.json';

import Aux from '../../../hoc/Aux';
import classes from './ConfigurationScreenNavbar.css';

class ConfigurationScreenNavbar extends Component {
  render() {
    let firstElement = false;
    let lastElement = false;
    let isSelected = false;
    let selected = 2;
    let counterForSelected = 0;

    let htmlItems = MenuItems.map( (rootElement, rootIndex) => {
      return (
        rootElement.items.map((element, innerIndex)  => {
          counterForSelected++;
          firstElement = false;
          lastElement = false;
          isSelected = false;

          if(innerIndex === 0) {
            firstElement = true;
          }
          if(innerIndex === (rootElement.items.length) -1 ) {
            lastElement = true;
          }
          
          if(window.location.pathname.includes(element.link)) {
            isSelected = true;
          }

          return <ConfigurationScreenNavbarItem
            key={element.id}
            name={element.name}
            icon={element.icon}
            isFirst={firstElement}
            isLast={lastElement}
            isSelected={isSelected}
            groupName={rootElement.name}
            link={element.link}
          />
        })
      )
    });


    return (
      <Aux>
        <div className={classes.NavHeader}>
          <h5>Moramma Settings</h5>
        </div>
        <ul className="nav flex-sm-column">
          {htmlItems}
        </ul>
      </Aux>
    );
  }
} 

export default ConfigurationScreenNavbar;
